(function($) {
  window.addEventListener('load', function() {

    let sliders = document.querySelectorAll('.slick-slider');

    sliders.forEach(function(element) {
      if(element.classList.contains('printed-issues-further-issues-slider')) return;
      if (element.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.contains('frame-type-1-column-container')) {
        $(element).slick();
      } else {
        $(element).slick({
          variableWidth: true,
          centerMode: true,
          slideToShow: 1,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev slick-arrow">${webmagazinSliderArrow}</button>`,
          nextArrow: `<button type="button" class="slick-next slick-arrow">${webmagazinSliderArrow}</button>`
        });
      }
    });
  });
})(jQuery);
